import { EstateResultItem } from 'queries';

// Split the trade records into two arrays, one for open and one for closed
export const fixupTrades = (trades: Partial<EstateResultItem>[]) => {
  const openTrades: Partial<EstateResultItem>[] = [];
  const closedTrades: Partial<EstateResultItem>[] = [];
  trades?.forEach((trade: Partial<EstateResultItem>) => {
    const element = JSON.parse(trade.essentialData!);
    if (element?.balance !== 'N/A' || element?.activityDesignatorCode?.code === 'P') {
      openTrades.push(trade);
    } else if (element?.activityDesignatorCode?.code) {
      closedTrades.push(trade);
    } else {
      openTrades.push(trade);
    }
  });
  return { openTrades: openTrades, closedTrades: closedTrades };
};
